import {
  Row,
  Col,
  UncontrolledTooltip,
  Collapse,
  Card,
  CardHeader,
  CardSubtitle,
  CardBody
} from "reactstrap"
import React, { useState, useEffect } from "react"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from 'lib/loading'
import Switch from 'react-switch';
import "./style.css";

const ListaRelatorios = ({form, onChange }) => {

  const [relatorios, setRelatorios]           = useState([])
  const [loading, setLoading]                 = useState(true)
  const [stateSwitch, setStateSwitch]         = useState(false);

  const lista = () => {
    try{
      const retorno = rest.get(rotas.usuarios+'relatorios.php?usuario_id='+form.usuario_id)
      retorno.then(ret => {
        console.log(ret)
        if ((ret.success) && (ret.success === 'S') && (ret.lista !== '')){
          setRelatorios(ret.lista)
        }
      })
      setLoading(false)
      return (true)
    }catch(err){
      setLoading(false)
      return (false)
    }
  }

  const selecionaAll = (value) =>{
    let lista = relatorios

    lista.forEach((tipo) => {
      tipo.relatorios.forEach((relatorio) =>{
        relatorio.status = value
      })
    })

    setRelatorios(lista)
    setStateSwitch(!stateSwitch)
  }

  const toggleTipo = (tipo_id, value) => {
    setRelatorios((prevState) =>
      prevState.map((item) =>
        item.id === tipo_id
          ? {
            ...item,
            relatorios: item.relatorios.map((relatorio) => ({
              ...relatorio,
              status: value,
            })),
            }
          : item
      )
    );
  };
  
  const collapsesToggle = (tipo) => {
    setRelatorios((prevState) =>
      prevState.map((item) =>
        item.tipo === tipo ? { ...item, isOpen: !item.isOpen } : item
      )
    );
  };

  const toggleSelecionado = (tipo_id, relatorio_id) => {
    setRelatorios((prevState) =>
      prevState.map((item) =>
        item.id === tipo_id
          ? {
              ...item,
              relatorios: item.relatorios.map((relatorio) =>
                relatorio.relatorio_id === relatorio_id
                  ? { ...relatorio, status: !relatorio.status }
                  : relatorio
              ),
            }
          : item
      )
    );
  };

  useEffect(() => {
    lista()
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (onChange) {
      onChange(relatorios); // Envia o estado atualizado para o FormUsuario
    }
  }, [relatorios, onChange]);

  if (loading) {
    return (
      <Row>
        <Loading tipo='componente' />
      </Row>
    )
  } else {
    return (
      <Col md='11'>

        <Col>
          <div
            aria-multiselectable  = {true}
            className             = "card-collapse"
            id                    = "accordion"
            role                  = "tablist"
          >
            <Col className="text-right p-0" >
              <span className="mb-0 m-2" >Selecionar todos </span>
              <Switch
                id        = 'btn-selecionaAll'
                height    = {15}
                width     = {35}
                checked   = {stateSwitch}
                onChange  = {(e)=>{selecionaAll(e)}}
              />
            </Col>

            {relatorios.map((item, index) => (

              <Card className="card-plain" key={'tipo_'+index}>
                <CardHeader role="tab" className="title d-flex header-switch-align pb-1">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    aria-expanded = {item.isOpen}
                    href          = "#"
                    data-parent   = "#accordion"
                    data-toggle   = "collapse"
                    onClick       = {(e) => {
                                      e.preventDefault();
                                      collapsesToggle(item.tipo);
                    }}
                    style={{ flexGrow: 1 }} // Permite que o nome do tipo ocupe todo o espaço disponível
                  >
                    {item.tipo} <i className="nc-icon nc-minimal-down" />
                  </a>
                  <Switch
                    id={`switch-tipo-${item.id}`}
                    height    = {15}
                    width     = {35}
                    checked   = {item.relatorios.every((relatorio) => relatorio.status)}
                    onChange  = {(checked) => toggleTipo(item.id, checked)}
                  />
                </CardHeader>

                <Collapse role="tabpanel" isOpen={item.isOpen} key={'tipoCol_'+index}>
                  <CardBody className="pb-0">
                      {item.relatorios.map((relatorio, indexRelat) => (
                        <CardSubtitle className="mb-3" key={'relatorios'+indexRelat} id={'tooltip'+relatorio.relatorio_id}>
                          <Switch
                            className = "react-switch mr-2"
                            height    = {15}
                            width     = {35}
                            checked   = {relatorio.status}
                            onChange  = {() => toggleSelecionado(item.id, relatorio.relatorio_id)}
                          />
                          {relatorio.nome_relatorio}
                          <UncontrolledTooltip placement='left' target={'tooltip'+relatorio.relatorio_id} delay={0}>
                            <i>{relatorio.descricao}</i>
                          </UncontrolledTooltip>
                          
                        </CardSubtitle>
                      ))}
                  </CardBody>
                </Collapse>
              </Card>

            ))}
            
          </div>

        </Col>
      </Col>
    )
  }
}

export default ListaRelatorios
